import { useAppContext } from "@/context/appContext";
import { useState, useEffect } from "react";

const ShareModal = () => {
  const { shareUrl } = useAppContext();
  const [copy, setCopy] = useState(false);
  const [pageUrl, setPageUrl] = useState("");

  const handleShareUrl = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 5000);
  };

  useEffect(() => {
    setPageUrl(
      typeof window === "undefined" ? "" : encodeURIComponent(shareUrl)
    );
  }, [shareUrl]);

  const handleClose = () => {
    setCopy(false);
  };

  return (
    <div
      className="modal fade"
      id="share-modal"
      tabIndex="-1"
      aria-labelledby="share-modalLabel1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div
            className="modal-header bg-cloud py-3"
            style={{ borderBottom: "1px solid #DDE3EE" }}
          >
            <h4 className="modal-title fw-semi-bold">Share</h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => handleClose()}
            ></button>
          </div>
          <div className="modal-body mx-auto body-4">
            <ul className="share-items ps-0 justify-content-center">
              {!pageUrl.includes("badgeid") &&
                !pageUrl.includes("certificate") && (
                  <li
                    className="share-social-link me-2 cs-tooltip cs-tooltip-bottom"
                    data-tooltip="Share on Facebook"
                  >
                    <a
                      href={
                        "https://www.facebook.com/sharer/sharer.php?u=" +
                        pageUrl
                      }
                      title="Share on Facebook"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.25"
                          y="0.25"
                          width="31.5"
                          height="31.5"
                          rx="3.75"
                          stroke="#253143"
                          strokeOpacity="0.5"
                          strokeWidth="0.5"
                        />
                        <path
                          d="M14.3325 16.6766H12.001V14.4019H14.3341V12.602C14.303 12.2002 14.3728 11.7975 14.5393 11.4176C14.7058 11.0377 14.9656 10.6883 15.3034 10.39C15.642 10.1244 16.0453 9.91742 16.4883 9.78201C16.9313 9.6466 17.4043 9.58566 17.8781 9.60298C18.5872 9.5948 19.2962 9.62838 19.9992 9.70344V11.7273H18.5435C18.3408 11.708 18.1353 11.7248 17.9416 11.7766C17.748 11.8283 17.5712 11.9138 17.4238 12.0268C17.2389 12.266 17.1548 12.5463 17.1838 12.8266V14.4019H19.7584L19.3953 16.6766H17.1798V22.4001H14.3325V16.6766Z"
                          fill="#253143"
                        />
                      </svg>
                    </a>
                    <a
                      href={
                        "https://www.facebook.com/sharer/sharer.php?u=" +
                        pageUrl
                      }
                      title="Share on Facebook"
                      rel="noreferrer"
                      target="_blank"
                      className="body-4 link-title"
                      role="button"
                    >
                      Facebook
                    </a>
                    <div className="tooltip-caret"></div>
                  </li>
                )}
              <li
                className="share-social-link cs-tooltip cs-tooltip-bottom"
                data-tooltip="Share on LinkedIn"
              >
                <a
                  href={
                    "https://www.linkedin.com/sharing/share-offsite/?url=" +
                    pageUrl
                  }
                  title="Share on LinkedIn"
                  rel="noreferrer"
                  target="_blank"
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="31.5"
                      height="31.5"
                      rx="3.75"
                      stroke="#253143"
                      strokeOpacity="0.5"
                      strokeWidth="0.5"
                    />
                    <path
                      d="M22 22.0001V17.5985C22 15.4454 21.5366 13.787 19.0222 13.787C18.55 13.7694 18.0818 13.8804 17.6677 14.1083C17.2536 14.3361 16.909 14.6722 16.6708 15.0806H16.6361V13.988H14.2539V21.9995H16.7369V18.0327C16.7369 16.988 16.9332 15.978 18.2271 15.978C19.5006 15.978 19.5196 17.1701 19.5196 18.0995V22.0001H22Z"
                      fill="#253143"
                    />
                    <path
                      d="M10.2104 13.9883H12.6974V21.9984H10.2104V13.9883Z"
                      fill="#253143"
                    />
                    <path
                      d="M11.4529 10C11.1663 9.99872 10.8857 10.0827 10.6469 10.2412C10.408 10.3998 10.2216 10.6258 10.1113 10.8906C10.0011 11.1554 9.97188 11.447 10.0275 11.7284C10.0831 12.0098 10.221 12.2683 10.4236 12.4712C10.6263 12.674 10.8846 12.812 11.1658 12.8676C11.4469 12.9233 11.7383 12.8941 12.0028 12.7837C12.2674 12.6733 12.4932 12.4868 12.6516 12.2477C12.8101 12.0087 12.8939 11.7279 12.8926 11.441C12.8926 11.0589 12.741 10.6923 12.4709 10.4221C12.2009 10.1518 11.8347 10 11.4529 10Z"
                      fill="#253143"
                    />
                  </svg>
                </a>
                <a
                  href={
                    "https://www.linkedin.com/sharing/share-offsite/?url=" +
                    pageUrl
                  }
                  title="Share on LinkedIn"
                  rel="noreferrer"
                  target="_blank"
                  className="body-4 link-title"
                  role="button"
                >
                  LinkedIn
                </a>
                <div className="tooltip-caret"></div>
              </li>
              <li
                className="share-social-link cs-tooltip cs-tooltip-bottom"
                data-tooltip="Share on Twitter"
              >
                <a
                  href={"https://twitter.com/intent/tweet?url=" + pageUrl}
                  title="Share on Twitter"
                  rel="noreferrer"
                  target="_blank"
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="31.5"
                      height="31.5"
                      rx="3.75"
                      stroke="#253143"
                      strokeOpacity="0.5"
                      strokeWidth="0.5"
                    />
                    <path
                      d="M19.6905 10.1106H21.6584L17.3592 15.0243L22.4168 21.7107H18.4567L15.355 17.6555L11.806 21.7107H9.83691L14.4353 16.455L9.5835 10.1106H13.6441L16.4478 13.8173L19.6905 10.1106ZM18.9998 20.5329H20.0903L13.0516 11.2266H11.8815L18.9998 20.5329Z"
                      fill="#253143"
                    />
                  </svg>
                </a>
                <a
                  className="4 link-title"
                  role="button"
                  href={"https://twitter.com/intent/tweet?url=" + pageUrl}
                  title="Share on Twitter"
                  rel="noreferrer"
                  target="_blank"
                >
                  Twitter
                </a>
                <div className="tooltip-caret"></div>
              </li>
              {/* <li className="share-social-link me-2">
                <a
                  href="https://www.instagram.com/contentstack"
                  title="Instagram"
                  rel="noreferrer"
                  target="_blank"
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="31.5"
                      height="31.5"
                      rx="3.75"
                      stroke="#253143"
                      strokeOpacity="0.5"
                      strokeWidth="0.5"
                    />
                    <g clipPath="url(#clip0_2208_4266)">
                      <path
                        d="M16 10.2605C17.8703 10.2605 18.0918 10.2687 18.8273 10.3016C19.5109 10.3316 19.8801 10.4465 20.1262 10.5422C20.4516 10.668 20.6867 10.8211 20.9301 11.0645C21.1762 11.3105 21.3266 11.543 21.4523 11.8684C21.548 12.1145 21.6629 12.4863 21.693 13.1672C21.7258 13.9055 21.734 14.127 21.734 15.9945C21.734 17.8648 21.7258 18.0863 21.693 18.8219C21.6629 19.5055 21.548 19.8746 21.4523 20.1207C21.3266 20.4461 21.1734 20.6812 20.9301 20.9246C20.684 21.1707 20.4516 21.3211 20.1262 21.4469C19.8801 21.5426 19.5082 21.6574 18.8273 21.6875C18.0891 21.7203 17.8676 21.7285 16 21.7285C14.1297 21.7285 13.9082 21.7203 13.1727 21.6875C12.4891 21.6574 12.1199 21.5426 11.8738 21.4469C11.5484 21.3211 11.3133 21.168 11.0699 20.9246C10.8238 20.6785 10.6734 20.4461 10.5477 20.1207C10.452 19.8746 10.3371 19.5027 10.307 18.8219C10.2742 18.0836 10.266 17.8621 10.266 15.9945C10.266 14.1242 10.2742 13.9027 10.307 13.1672C10.3371 12.4836 10.452 12.1145 10.5477 11.8684C10.6734 11.543 10.8266 11.3078 11.0699 11.0645C11.316 10.8184 11.5484 10.668 11.8738 10.5422C12.1199 10.4465 12.4918 10.3316 13.1727 10.3016C13.9082 10.2687 14.1297 10.2605 16 10.2605ZM16 9C14.0996 9 13.8617 9.0082 13.1152 9.04102C12.3715 9.07383 11.8602 9.19414 11.4172 9.36641C10.9551 9.54687 10.5641 9.78477 10.1758 10.1758C9.78477 10.5641 9.54688 10.9551 9.36641 11.4145C9.19414 11.8602 9.07383 12.3687 9.0082 13.8617 9 14.0996 9 16C9 17.9004 9.0082 18.1383 9.04102 18.8848C9.07383 19.6285 9.19414 20.1398 9.36641 20.5828C9.54688 21.0449 9.78477 21.4359 10.1758 21.8242C10.5641 22.2125 10.9551 22.4531 11.4145 22.6309C11.8602 22.8031 12.3687 22.9234 13.1125 22.9562C13.859 22.9891 14.0969 22.9973 15.9973 22.9973C17.8977 22.9973 18.1355 22.9891 18.882 22.9562C19.6258 22.9234 20.1371 22.8031 20.5801 22.6309C21.0395 22.4531 21.4305 22.2125 21.8187 21.8242C22.207 21.4359 22.4477 21.0449 22.6254 20.5855C22.7977 20.1398 22.918 19.6313 22.9508 18.8875C22.9836 18.141 22.9918 17.9031 22.9918 16.0027C22.9918 14.1023 22.9836 13.8645 22.9508 13.118C22.918 12.3742 22.7977 11.8629 22.6254 11.4199C22.4531 10.9551 22.2152 10.5641 21.8242 10.1758C21.4359 9.7875 21.0449 9.54688 20.5855 9.36914C20.1398 9.19687 19.6313 9.07656 18.8875 9.04375C18.1383 9.0082 17.9004 9 16 9Z"
                        fill="#253143"
                      />
                      <path
                        d="M16 12.4043C14.0148 12.4043 12.4043 14.0148 12.4043 16C12.4043 17.9852 14.0148 19.5957 16 19.5957C17.9852 19.5957 19.5957 17.9852 19.5957 16C19.5957 14.0148 17.9852 12.4043 16 12.4043ZM16 18.3324C14.7121 18.3324 13.6676 17.2879 13.6676 16C13.6676 14.7121 14.7121 13.6676 16 13.6676C17.2879 13.6676 18.3324 14.7121 18.3324 16C18.3324 17.2879 17.2879 18.3324 16 18.3324Z"
                        fill="#253143"
                      />
                      <path
                        d="M20.5773 12.2621C20.5773 12.7269 20.2 13.1015 19.7379 13.1015C19.273 13.1015 18.8984 12.7242 18.8984 12.2621C18.8984 11.7972 19.2758 11.4226 19.7379 11.4226C20.2 11.4226 20.5773 11.8 20.5773 12.2621Z"
                        fill="#253143"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2208_4266">
                        <rect
                          width="14"
                          height="14"
                          fill="white"
                          transform="translate(9 9)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <span className="body-5">Instagram</span>
              </li>
              <li className="share-social-link me-2">
                <a
                  href="https://github.com/contentstack"
                  title="GitHub"
                  rel="noreferrer"
                  target="_blank"
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="31.5"
                      height="31.5"
                      rx="3.75"
                      stroke="#253143"
                      strokeOpacity="0.5"
                      strokeWidth="0.5"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.0058 9C12.1318 9 9 12.2083 9 16.1774C9 19.3502 11.0066 22.0358 13.7904 22.9864C14.1384 23.0578 14.2659 22.8319 14.2659 22.6419C14.2659 22.4755 14.2544 21.9052 14.2544 21.3109C12.3056 21.7388 11.8997 20.4553 11.8997 20.4553C11.5866 19.6235 11.1225 19.4097 11.1225 19.4097C10.4846 18.97 11.169 18.97 11.169 18.97C11.8765 19.0175 12.2478 19.7067 12.2478 19.7067C12.874 20.7999 13.8831 20.491 14.2891 20.3009C14.3471 19.8374 14.5328 19.5166 14.7299 19.3384C13.1756 19.172 11.5402 18.5541 11.5402 15.7971C11.5402 15.0128 11.8184 14.3712 12.2593 13.8721C12.1897 13.6939 11.9461 12.957 12.3289 11.9708C12.3289 11.9708 12.9205 11.7806 14.2543 12.7075C14.8253 12.5504 15.4142 12.4705 16.0058 12.4698C16.5973 12.4698 17.2003 12.5531 17.7572 12.7075C19.0911 11.7806 19.6826 11.9708 19.6826 11.9708C20.0655 12.957 19.8217 13.6939 19.7522 13.8721C20.2046 14.3712 20.4714 15.0128 20.4714 15.7971C20.4714 18.5541 18.836 19.16 17.27 19.3384C17.5253 19.5641 17.7456 19.9918 17.7456 20.6692C17.7456 21.6317 17.7341 22.4042 17.7341 22.6418C17.7341 22.8319 17.8617 23.0578 18.2096 22.9865C20.9933 22.0357 23 19.3502 23 16.1774C23.0114 12.2083 19.8682 9 16.0058 9Z"
                      fill="#253143"
                    />
                  </svg>
                </a>
                <span className="body-5">GitHub</span>
              </li>
              <li className="share-social-link me-2">
                <a
                  href="https://www.youtube.com/contentstack"
                  title="YouTube"
                  rel="noreferrer"
                  target="_blank"
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.25"
                      y="0.25"
                      width="31.5"
                      height="31.5"
                      rx="3.75"
                      stroke="#253143"
                      strokeOpacity="0.5"
                      strokeWidth="0.5"
                    />
                    <path
                      d="M16 22C15.9496 22 10.9802 22 9.75069 21.6434C9.41179 21.552 9.10184 21.3652 8.85291 21.1024C8.60397 20.8396 8.42508 20.5103 8.33475 20.1486C8.10485 18.7845 7.99292 17.4007 8.00037 16.0146C7.99271 14.6282 8.10465 13.244 8.33475 11.8797C8.42562 11.5158 8.60421 11.1839 8.85259 10.9173C9.10098 10.6508 9.41042 10.4588 9.74989 10.3609C10.9794 10 15.9496 10 16 10C16.0504 10 21.0206 10 22.2501 10.3609C22.5895 10.4591 22.8988 10.6511 23.1471 10.9176C23.3955 11.1842 23.5742 11.5159 23.6653 11.8797C23.8953 13.244 24.0072 14.6282 23.9996 16.0146C24.0073 17.3992 23.8953 18.7817 23.6653 20.1443C23.5746 20.5057 23.3957 20.8347 23.147 21.0975C22.8983 21.3602 22.5887 21.5472 22.2501 21.6391C21.0198 22 16.0496 22 16 22ZM14.3649 13.4731V18.5457L18.5487 16.0103L14.3649 13.4731Z"
                      fill="#253143"
                    />
                  </svg>
                </a>
                <span className="body-5">Youtube</span>
              </li> */}
            </ul>
            <div className="row align-items-center pt-4">
              <div className="fw-semi-bold text-stone-700 pb-2 body-5">
                Link
              </div>
              <div
                className="row col-12"
                onClick={() => handleShareUrl()}
              >
                <div
                  className="col-10 body-4"
                  style={{ wordWrap: "break-word" }}
                >
                  {shareUrl}
                </div>
                <div className="col-2">
                  <div>
                    <span
                      role="button"
                      className="material-symbols-outlined share-copy-btn ps-3 cs-tooltip cs-tooltip-bottom"
                      data-tooltip="Click to copy"
                    >
                      file_copy
                      <div className="tooltip-caret"></div>
                    </span>
                  </div>
                  {copy ? (
                    <div className="text-stone-700 ps-3">Copied!</div>
                  ) : (
                    <div
                      className="visibility-hide"
                      aria-hidden="true"
                    >
                      Copied!
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="d-flex justify-content-between ps-2 col-2" onClick={() => handleShareUrl()}>
                <div>{shareUrl}</div>
                <div className="">
                  <div>
                    <span
                      role="button"
                      className="body-3 material-symbols-outlined ps-3"
                    >
                      file_copy
                    </span>
                  </div>
                  {copy ? (
                    <div className="text-stone-700 ps-3">Copied!</div>
                  ) : (
                    <div className="visibility-hide">Copied!</div>
                  )}
                </div>
              </div> */}
            </div>
          </div>
          <div
            className="modal-footer py-3"
            style={{ borderTop: "1px solid #DDE3EE" }}
          >
            {/* <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button> */}
            <a
              href="#"
              data-bs-dismiss="modal"
              className="link-basic"
              onClick={() => handleClose()}
            >
              Close
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
